import {AssistantMessage} from "@/ai-assistant/interfaces";

/**
 * The first turn the assistant will still be told about, once the conversation
 * has outgrown what travels with a question.
 *
 * Nothing is archived: the client resends the conversation at every turn and
 * only its last turns are carried, so past a certain length the assistant stops
 * being told about the beginning. Returns the id of the oldest turn still
 * carried — what sits above it is no longer part of the exchange, and the
 * pharmacist has to be able to see where that line falls.
 *
 * Null while everything still travels, which is the ordinary case.
 *
 * The count mirrors what the store actually sends: a turn still being written
 * is not a premise, and neither is an empty one.
 */
export const carriedFrom = (messages: AssistantMessage[], limit: number): string | null => {
    const carried = messages.filter(message => !message.isStreaming && message.content.length > 0);

    return carried.length > limit ? carried[carried.length - limit].id : null;
};
